import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, TableLangValue } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const TypeForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="StructureActivity" id={match.params.id} initialValues={{ name: '', parameters: {} }}>
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row className="d-flex align-items-center">
                  <Col lg={12}>
                    <Input name="alias" />
                  </Col>
                  <Col lg={12} className="d-flex align-items-center">
                    <TableLangValue name="name" />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

TypeForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default TypeForm;
